<template>
	<div>
		<Hrader :idShwo="99" @skipCompents="landingClcik"></Hrader>
		<div style="height: 110px"></div>

		<div class="rectangle-platform">
			<div class="rectngle-plat-vector">
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 1 }" @click="serverClick(1)">
					<img v-if="ids == 1" src="../../assets/OverviewCertifiedSlices/Group 1395@2x.png" class="image-rectng" />
					<img v-else src="../../assets/OverviewCertifiedSlices/Group 1477@2x.png" class="image-rectng" />
					<div class="title-assrts">账户总览</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 2 }" @click="serverClick(2)">
					<img v-if="ids == 2" src="../../assets/OverviewCertifiedSlices/Vector@2x1.png" class="image-rectng" />
					<img v-else src="../../assets/OverviewCertifiedSlices/Group 1419@2x.png" class="image-rectng" />
					<div class="title-assrts">我要提现</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 3 }" @click="serverClick(3)">
					<img v-if="ids == 3" src="../../assets/paynec/Group 1415@2x.png" style="height: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/OverviewCertifiedSlices/Group 1415@2x.png" style="height: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">提现记录</div>
				</div>
				<div class="rectng-width" v-if="userInfo.brokerageEnabled" :class="{ 'rectng-width1': ids == 8 }"
					@click="serverClick(8)">
					<img v-if="ids == 8" src="../../assets/paynec/Group 1340@2x.png" style="height: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/OverviewCertifiedSlices/Group 1340@2x.png" style="height: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">我的佣金</div>
				</div>
				<div class="rectng-width" v-if="userInfo.brokerageEnabled" :class="{ 'rectng-width1': ids == 4 }"
					@click="serverClick(4)">
					<img v-if="ids == 4" src="../../assets/paynec/Vector@2x (5).png" style="height: 16px; height: 15px"
						class="image-rectng" />
					<img v-else src="../../assets/OverviewCertifiedSlices/Vector@2x(3).png" style="height: 16px; height: 15px"
						class="image-rectng" />
					<div class="title-assrts">我的客户</div>
				</div>
				<div class="bor-top1"></div>
				<!-- <div class="rectng-width" :class="{ 'rectng-width1': ids == 5 }" @click="serverClick(5)">
					<img v-if="ids == 5" src="../../assets/contact_slices/Group 1140@121x.png" style="width: 15px; height: 16px" class="image-rectng" />
					<img v-else src="../../assets/contact_slices/Group 1140@2x.png" style="width: 15px; height: 16px" class="image-rectng" />
					<div class="title-assrts">我要卖卡</div>
				</div> -->
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 7 }" @click="serverClick(7)">
					<img v-if="ids == 7" src="../../assets/contact_slices/Group211292x.png" style="width: 14px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/contact_slices/Group 1129@2x (1).png" style="width: 14px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">卖卡记录</div>
				</div>
				<!-- <div class="rectng-width" :class="{ 'rectng-width1': ids == 6 }" @click="serverClick(6)">
					<img v-if="ids == 6" src="../../assets/paynec/Vector@2x (10).png" style="width: 16px; height: 16px" class="image-rectng" />
					<img v-else src="../../assets/paynec/Vector@2x (12).png" style="width: 16px; height: 16px" class="image-rectng" />
					<div class="title-assrts">统计记录</div>
				</div> -->
				<div class="bor-top1"></div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 9 }" @click="serverClick(9)">
					<img v-if="ids == 9" src="../../assets/paynec/Vector@2x (13).png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/paynec/Vector@2x (15).png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">账号设置</div>
				</div>
				<div class="bor-top1" v-if="information && information?.reviewStatus==20"></div>
				<div class="rectng-width" v-if="information && information?.reviewStatus==20"
					:class="{ 'rectng-width1': ids == 12 }" @click="serverClick(12)">
					<img v-if="ids == 12 && information?.reviewStatus==20" src="../../assets/paynecHome/Subtract.png"
						style="width: 16px; height: 16px" class="image-rectng" />
					<img v-else src="../../assets/paynecHome/paynecSubtract.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">API对接管理</div>
				</div>
				<!-- <div class="bor-top1" v-if="information && information?.reviewStatus==20"></div> -->
				<div class="rectng-width" v-if="information && information?.reviewStatus==20"
					:class="{ 'rectng-width1': ids == 11 }" @click="serverClick(11)">
					<img v-if="ids == 11" src="../../assets/paynecHome/groupPaynecHome.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/paynecHome/group.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">API订单列表</div>
				</div>
				<!-- <div class="bor-top1" v-if="information && information?.reviewStatus==20"></div> -->
				<div class="rectng-width" v-if="information && information?.reviewStatus==20"
					:class="{ 'rectng-width1': ids == 13 }" @click="serverClick(13)">
					<img v-if="ids == 13" src="../../assets/paynecHome/subtractAPi.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/paynecHome/subtractAPiPaync.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">API收单统计</div>
				</div>
				<!-- <div class="bor-top1" v-if="information && information?.reviewStatus==20"></div> -->
				<div class="rectng-width" v-if="information && information?.reviewStatus==20"
					:class="{ 'rectng-width1': ids == 14 }" @click="serverClick(14)">
					<img v-if="ids == 14" src="../../assets/paynecHome/SubtractPaycnHome.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<img v-else src="../../assets/paynecHome/statisticPaync.png" style="width: 16px; height: 16px"
						class="image-rectng" />
					<div class="title-assrts">账户资金日志</div>
				</div>
			</div>

			<div class="rectangle1" v-show="ids == 1" @click="viewClick">
				<div class="rectgle-flex"></div>
				<div class="flex-post">
					<div>
						<img src="@/assets/Home_slices1/Group 1212@2x.png" style="width: 126px; height: 78px" />
					</div>
					<div>
						<div class="flex-assets">
							<div class="flex-text">
								结算
								<span class="time">{{ dataObj.pubTime }}</span>
							</div>
						</div>
						<div class="flex-title-text">{{ dataObj.content }}</div>
					</div>
				</div>
				<div class="flex-right">
					<div class="flex-title-views">查看</div>
					<div>
						<img src="@/assets/Home_slices1/Group 1213@2x.png" style="width: 24px; height: 24px" />
					</div>
				</div>
			</div>
			<div class="rectangle1" style="height: 0" v-show="ids != 1"></div>
			<div class="content" v-if="ids == 1">
				<div class="rectangleSpan" v-if="userInfo.brokerageEnabled">
					<div class="reactnale-assets">
						<div>
							<img src="@/assets/OverviewCertifiedSlices/image 47@2x.png" style="width: 24px; height: 24px" />
						</div>
						<div class="distributors">分销商 · 分销代码 : {{ userInfo.proxyCode }}</div>
					</div>

					<div class="reactnale-assets1">
						<div class="distributors">
							<span class="commission">可提现佣金</span>
							<span class="symbol">￥</span>
							<span class="money">{{ userInfo.proxyAmount || 0}}</span>
						</div>
					</div>

					<div class="border-left"></div>
					<div class="reactnale-assets1" style="margin-left: -10px">
						<div class="distributors">
							<span class="commission">待结算佣金</span>
							<span class="symbol">￥</span>
							<span class="money">{{reportData.waitOrderAmount || 0}}</span>
						</div>
					</div>

					<div class="border-left"></div>
					<div class="reactnale-assets1" style="margin-left: -10px">
						<div class="distributors">
							<span class="commission">累计结算</span>
							<span class="symbol">￥</span>
							<span class="money">{{ reportData.totalAmount || 0 }}</span>
						</div>
					</div>
				</div>
				<div class="content-assets">
					<div class="flex-cement">
						<img src="@/assets/OverviewCertifiedSlices/Group 1396@2x.png" style="width: 13px; height: 16px" />
						<div class="cement">账户总览</div>
					</div>
					<div class="border-top"></div>
					<div class="flex-usere">
						<img :src="userInfo.avatar" v-if="userInfo.avatar"
							style="width: 76px; height: 76px; border-radius: 100px" />
						<img src="@/assets/default-header.png" v-else style="width: 76px; height: 76px; border-radius: 100px" />
						<div>
							<div class="user-info">{{ userInfo.nickname }}</div>
							<div class="user-phone" style="display: flex; align-items: center">
								<div style="padding-right: 5px">
									{{ hideMobile(userInfo.mobile) }}
									<span v-if="userInfo.realType === 3">| 已认证</span>
								</div>
								<img src="@/assets/Vector@2x (11).png" style="width: 12px; height: 14px"
									v-if="userInfo.realType === 3" />
							</div>
						</div>
						<div class="user-left">
							<div class="user-price">
								<span style="font-size: 12px">￥</span>
								<span>{{ userInfo.amount }}</span>
							</div>
							<div class="user-title">可提现金额</div>
						</div>
						<div class="user-left" style="margin-left: 74px">
							<div class="user-price">
								<span style="font-size: 12px">￥</span>
								<span>{{ userInfo.allSellCardAmount }}</span>
							</div>
							<div class="user-title">累计结算金额</div>
						</div>
						<div class="flex-list-tiele">
							<div class="user-left">
								<div class="withdrawal" v-if="userInfo.realType < 2" @click="certificationClick">提现</div>
								<div class="after-real-name" v-if="userInfo.realType < 2" @click="certificationClick">
									实名认证后可提现
									<span style="color: #ff3333">去认证 ></span>
								</div>
								<div class="withdrawal" style="background-color: #ff3333" v-if="userInfo.realType >= 2"
									@click="cashClick">提现</div>
							</div>
							<div>
								<div class="withdrawal" v-if="information?.reviewStatus==20" style="margin-left: 20px;">申请API接口
								</div>
								<div class="withdrawal" v-else style="background-color: #1D75FD; margin-left: 20px;"
									@click="centerDialogVisible = true">申请API接口
								</div>
								<div class="after-real-scikck" style="color: #ff3333;" v-if="information?.reviewStatus==30" @click="certificationClick">
									已驳回待完善
								</div>
							</div>

							<div>
								<div @click="centerDialogVisibleShow = true" class="withdrawal"
									style="background-color: #94D575; margin-left: 20px;" v-if="information?.reviewStatus==20 || information?.reviewStatus==30">查看账户信息
								</div>
							</div>

						</div>
					</div>
					<div class="border-top"></div>
					<div class="flex-top-bor">
						<div class="flex-left">
							<img style="width: 15px; height: 13px" src="@/assets/OverviewCertifiedSlices/Vector@2x(4).png" />
							<div style="margin-left: 7px">最近提交回收的卡</div>
						</div>
						<!-- <div class="flex-rights">
							<div style="margin-right: 7px">查看全部</div>
							<img src="@/assets/OverviewCertifiedSlices/Group 1444@2x.png" style="width: 16px; height: 16px" />
						</div> -->
					</div>
					<div style="height: 21px"></div>
					<el-table :data="ListObj" style="width: 100%">
						<el-table-column prop="createTime" label="日期" width="280" />
						<el-table-column prop="no" label="批次号" width="280" />
						<el-table-column prop="categoryName" label="卡劵类型" />
						<el-table-column label="卡种" min-width="190">
							<template v-slot="{ row }">
								<view>
									{{row.cardInfoStr.name}}
								</view>
							</template>
						</el-table-column>
						<el-table-column prop="sourcePrice" label="面值" />
						<el-table-column prop="status" label="成功" />
					</el-table>

					<div style="display: flex; align-items: center; justify-content: space-between">
						<div class="pagination-contact">
							<el-pagination @current-change="handleCurrentChange" background layout="total, prev, pager, next,jumper"
								:total="total" />
						</div>
						<div class="want-to-sell" @click="sellClick">我要卖卡</div>
					</div>
				</div>
			</div>
			<keep-alive>
				<component
					v-if="activeTabComponent"
					:is="activeTabComponent"
					:key="activeTabKey"
					@clickPush="clickDeatis"
					@reoutnCart="reoutnCart"
					@withdrawSuccess="handleWithdrawSuccess"
				/>
			</keep-alive>
		</div>
	</div>
	<Tabr></Tabr>
	<div>
		<Customer></Customer>
	</div>

	<el-dialog v-model="centerDialogVisible" title="提交企业信息" width="640" align-center>
		<div>
			<el-form ref="formEl" label-position="top" style="max-width: 600px" :model="ruleForm" :rules="rules"
				label-width="auto">
				<el-form-item label="公司名称" prop="merchantName">
					<el-input v-model="ruleForm.merchantName" />
				</el-form-item>
				<el-form-item label="机构代码" prop="institutionCode">
					<el-input v-model="ruleForm.institutionCode" />
				</el-form-item>
				<el-form-item label="法人姓名" prop="name">
					<el-input v-model="ruleForm.name" />
				</el-form-item>
				<el-form-item label="身份证号" prop="idCard">
					<el-input v-model="ruleForm.idCard" />
				</el-form-item>
				<el-form-item label="公司地址" prop="address">
					<el-input v-model="ruleForm.address" />
				</el-form-item>
				<el-form-item label="公司实际运营地址" prop="operatingAddress">
					<el-input v-model="ruleForm.operatingAddress" />
				</el-form-item>
				<el-form-item label="公司运营网站" prop="operateWebsite">
					<el-input v-model="ruleForm.operateWebsite" />
				</el-form-item>
				<el-form-item label="公司资质" prop="isCardUrlSuccess">
					<el-upload v-model:file-list="fileList1" @success="success" :class="{disabled:ruleForm.isCardUrl}"
						@remove="remove" :action="evn.baseURL+'/infra/file/upload'" list-type="picture-card" :limit="1">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传法人身份证正面
						</div>
					</el-upload>
					<el-upload v-model:file-list="fileList2" :class="{disabled:ruleForm.theCardUrl}" @success="success1"
						@remove="remove1" :action="evn.baseURL+'/infra/file/upload'" style="margin-left: 20px;"
						list-type="picture-card">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传法人身份证背面
						</div>
					</el-upload>
					<el-upload v-model:file-list="fileList3" :class="{disabled:ruleForm.licenseUrl}" @success="success2"
						@remove="remove2" :action="evn.baseURL+'/infra/file/upload'" list-type="picture-card"
						style="margin-left: 20px;">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传公司营业执照
						</div>
					</el-upload>
				</el-form-item>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button type="primary" @click="save">
					确定
				</el-button>
			</div>
		</template>
	</el-dialog>

	<el-dialog v-model="centerDialogVisibleShow" title="查看提交企业信息" width="640" align-center>
		<div>
			<el-form ref="formEl" label-position="top" style="max-width: 600px" :model="ruleForm" :rules="rules"
				label-width="auto">
				<el-form-item label="公司名称">
					<el-input disabled v-model="information.merchantName" />
				</el-form-item>
				<el-form-item label="机构代码">
					<el-input disabled v-model="information.institutionCode" />
				</el-form-item>
				<el-form-item label="法人姓名">
					<el-input disabled v-model="information.name" />
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input disabled v-model="information.idCard" />
				</el-form-item>
				<el-form-item label="公司地址">
					<el-input disabled v-model="information.address" />
				</el-form-item>
				<el-form-item label="公司实际运营地址">
					<el-input disabled v-model="information.operatingAddress" />
				</el-form-item>
				<el-form-item label="公司运营网站">
					<el-input disabled v-model="information.operateWebsite" />
				</el-form-item>
				<el-form-item label="签署文件：" label-position="right">
					<div class="downloadFile" @click="clickType">下载文件</div>
				</el-form-item>
				<el-form-item label="公司资质" prop="isCardUrlSuccess">
					<el-upload disabled v-model:file-list="fileList4" @success="success" class="disabled"
						@remove="remove" :action="evn.baseURL+'/infra/file/upload'" list-type="picture-card" :limit="1">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传法人身份证正面
						</div>
					</el-upload>
					<el-upload disabled v-model:file-list="fileList5" class="disabled" @success="success1"
						@remove="remove1" :action="evn.baseURL+'/infra/file/upload'" style="margin-left: 20px;"
						list-type="picture-card">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传法人身份证背面
						</div>
					</el-upload>
					<el-upload disabled v-model:file-list="fileList6" class="disabled" @success="success2"
						@remove="remove2" :action="evn.baseURL+'/infra/file/upload'" list-type="picture-card"
						style="margin-left: 20px;">
						<div class="direction">
							<el-icon style="font-size: 26px;">
								<Plus />
							</el-icon>
							请上传公司营业执照
						</div>
					</el-upload>
				</el-form-item>
			</el-form>
		</div>
	</el-dialog>

</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted
	} from 'vue';
	import evn from '@/utils/evn.js';
	import Tabr from '@/components/tabr.vue';
	import Customer from '@/components/customer.vue';
	import Details from './components/index.vue';
	import Recovery from './components/recovery.vue';
	import Registration from './components/registration.vue';
	import Recoverycoitn from './components/recoverycoitn.vue';
	import orderList from './components/orderList.vue';
	import orderManagement from './components/orderManagement.vue';
	import orderStatistics from './components/orderStatistics.vue'
	import accountFundLog from './components/accountFundLog.vue'
	import RecoverycoitnCopy from './components/recoverycoitnCopy.vue';
	import Settings from './components/settings.vue';
	import ContactUs from './components/contactUs.vue';
	import Mailajilu from './components/maikajilu.vue';
	import MaikajiluCopy from './components/maikajiluCopy.vue';
	import Hrader from '@/components/header.vue';
	import {
		merchantApplyFor
	} from '@/utils/api.js'
	import {
		memberUserGet
	} from '@/utils/api.js';
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus';
	import {
		cardHots,
		noticePub
	} from '@/utils/api.js';
	import dayjs from 'dayjs';
	import {
		useRouter,
		useRoute
	} from 'vue-router';
	import {
		getProxyReport,
		infraonfigCompany,
		configUserProtocol,
		infrafilepdf,
		infraConfigPrivacyProtocol,
		cardListQa,
		appApiCardListQa,
		cardOrderPage,
		merchantDetails
	} from '@/utils/api.js';
	let router = useRouter();
	let route = useRoute();
	let showDetails = ref(true);
	let dataImage = ref('');
	let dataList = ref([]);
	let dataListObj = ref([]);
	let showIds = ref(true);
	let title = ref('');
	let objList = ref({});
	let dataObj = ref({});
	let dataListTitle = ref([]);
	let ListObj = ref([]);
	let total = ref(0);
	let pageNo = ref(1);
	let ids = ref(1);
	let userInfo = ref({});
	let reportData = ref({})

	const tabComponents = {
		2: ContactUs,
		3: Recovery,
		4: Registration,
		5: Mailajilu,
		6: RecoverycoitnCopy,
		7: Recoverycoitn,
		8: Details,
		11: orderList,
		12: orderManagement,
		13: orderStatistics,
		14: accountFundLog,
	}

	const activeTabComponent = computed(() => {
		if (ids.value === 9) {
			return showIds.value ? Settings : MaikajiluCopy
		}
		return tabComponents[ids.value] || null
	})

	const activeTabKey = computed(() => {
		if (ids.value === 9) {
			return showIds.value ? '9-settings' : '9-maikajilu'
		}
		return String(ids.value)
	})
	let headers = ref({
		"Content-Type": "multipart/form-data"
	})
	let centerDialogVisible = ref(false);
	let centerDialogVisibleShow = ref(false);

	const ruleForm = reactive({
		merchantName: '',
		name: '',
	})
	const validateIdCard = (rule, value, callback) => {
		const reg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/
		if (!reg.test(value)) {
			callback(new Error('请输入有效的身份证号码'))
		} else {
			callback()
		}
	}
	const validImagestor = (rule, value, callback) => {
		if (!ruleForm.isCardUrl || !ruleForm.theCardUrl || !ruleForm.licenseUrl) {
			callback(new Error('请选择图片'))
		} else {
			callback()
		}
	}
	const rules = reactive({
		name: [{
			required: true,
			message: '请输入法人姓名',
			trigger: 'blur'
		}],
		merchantName: [{
			required: true,
			message: '请输入公司名称',
			trigger: 'blur'
		}],
		institutionCode: [{
			required: true,
			message: '请输入机构代码',
			trigger: 'blur'
		}],
		idCard: [{
				required: true,
				message: '请输入身份证号',
				trigger: 'blur'
			},
			{
				validator: validateIdCard,
				trigger: 'blur'
			}
		],
		address: [{
			required: true,
			message: '请输入公司地址',
			trigger: 'blur'
		}],
		operatingAddress: [{
			required: true,
			message: '请输入公司运营地址',
			trigger: 'blur'
		}],
		operateWebsite: [{
			required: true,
			message: '请输入公司运营网站',
			trigger: 'blur'
		}],
		isCardUrlSuccess: [{
			required: true,
			validator: validImagestor,
			trigger: 'blur'
		}]
	})

	function clickType() {
		if(!information.value.signFile){
			ElMessage({
				message: '当前暂无下载文件',
				type: 'error',
			})
			return;
		}
		downFile(information.value.signFile);
	}

	//文件下载
	function downFile(e) {
		let fileUrl = e;
		getBlob(fileUrl).then(blob => {
			saveAs(blob, '签署文件地址.pdf')
		})
	}

	//通过文件下载url拿到对应的blob对象
	function getBlob(url) {
		return new Promise(resolve => {
			const xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
			}
			xhr.send()
		})
	}
	
	//下载文件
	function saveAs(blob, filename) {
		var link = document.createElement('a')
		link.href = window.URL.createObjectURL(blob)
		link.download = filename
		link.click()
	}

	const success = (item) => {
		ruleForm.isCardUrl = item.data;
	}
	const remove = (item) => {
		ruleForm.isCardUrl = '';
	}

	const success1 = (item) => {
		ruleForm.theCardUrl = item.data;
	}
	const remove1 = (item) => {
		ruleForm.theCardUrl = '';
	}
	const success2 = (item) => {
		console.log(1111111, item)
		ruleForm.licenseUrl = item.data;
	}
	const remove2 = (item) => {
		ruleForm.licenseUrl = '';
	}
	let formEl = ref('');
	const save = () => {
		formEl.value.validate(valid => {
			if (!valid) return;
			merchantApplyFor(ruleForm).then(res => {
				if (res.code == 500) {
					ElMessage({
						message: res.msg,
						type: 'error',
					})
				} else {
					centerDialogVisible.value = false;
					ElMessage({
						message: '提交成功等待审核',
						type: 'success',
					})
				}
			})
		})
	}
	const skipClick = (item) => {
		router.push({
			path: item
		});
	};
	const reoutnCart = () => {
		showIds.value = !showIds.value;
	};
	const cashClick = async () => {
		await refreshUserInfo();
		ids.value = 2;
	};
	const certificationClick = () => {
		ids.value = 9;
		showIds.value = false;
	}
	const sellClick = () => {
		// ids.value = 7;
		router.push({
			path: 'cardVoucher'
		});
	}
	const clickDeatis = async () => {
		await refreshUserInfo();
		ids.value = 2;
	}
	const handleWithdrawSuccess = async () => {
		await refreshUserInfo();
		ids.value = 3;
	}
	const info = async () => {
		const res = await infraonfigCompany();
		dataImage.value = res.data.value;
		const ref = await configUserProtocol();
		const ret = await infrafilepdf({
			path: ref.data.value
		});
		dataList.value = ret.data;
		const dataRes = await infraConfigPrivacyProtocol();
		const retList = await infrafilepdf({
			path: dataRes.data.value
		});
		dataListObj.value = retList.data;
	};
	const into = async () => {
		const res = await cardListQa();
		console.log(res);
	};
	const refreshUserInfo = async () => {
		const res = await memberUserGet();
		if (res?.data) {
			localStorage.setItem('information', JSON.stringify(res.data));
			userInfo.value = res.data;
		}
		return res;
	};
	const serverClick = async (item) => {
		if (item == 2) {
			const res = await refreshUserInfo();
			if (res?.data?.realType < 2) {
				ElMessageBox.confirm('为保障您的合法权益以及平台合法运营，请进行实名认证，未认证不能进行卡券核销。', '提示', {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					})
					.then(() => {
						ids.value = 9;
					})
					.catch((ref) => {
						router.go(-1);
					});
				return false;
			}
		} else {
			await refreshUserInfo();
		}
		closedClick();
		ids.value = item;
		if (item == 1) {
			getProxyReportInfo();
			infTops();
		}
	};
	const infoSever = async () => {
		let ref = await appApiCardListQa();
		dataListTitle.value = ref.data;
		dataListTitle.value.forEach((item) => {
			item.updateTime = dayjs(item.updateTime).format('YYYY年MM月DD日');
		});
	};
	const aborConler = (item) => {
		objList.value = item;
		showDetails.value = false;
	};
	const closedClick = () => {
		showDetails.value = true;
	};
	const infoAsync = async () => {
		const res = await cardHots();
		dataList.value = res.data;
		const ref = await noticePub();
		dataObj.value = ref.data;
		if (dataObj.value.pubTime) {
			dataObj.value.pubTime = dayjs(dataObj.value.pubTime).format('YYYY/MM/DD');
		}
	};
	const viewClick = () => {
		console.log(11111);
		router.push({
			path: '/dynamics'
		});
		console.log(11111);
	};
	const hideMobile = (mobile) => {
		if (!mobile) {
			return '';
		}
		return mobile.substring(0, 3) + '****' + mobile.substring(mobile.length - 4);
	};
	const infTops = async () => {
		let res = await cardOrderPage({
			pageNo: pageNo.value,
			pageSize: 10
		});
		ListObj.value = res.data?.list;
		if (!res.data) {
			return false;
		}
		ListObj.value.forEach((item, index) => {
			item.cardInfoStr = JSON.parse(item.cardInfoStr);
		})
		ListObj.value.forEach((item) => {
			item.createTime = dayjs(item.createTime).format('YYYY/MM/DD HH:mm:ss');
			if (item.status === 1) {
				item.status = '交易成功';
			} else if (item.status === 2) {
				item.status = '交易失败';
			} else {
				item.status = '处理中';
			}
		});
		total.value = res.data.total;
	};
	const handleCurrentChange = (item) => {
		pageNo.value = item;
		infTops();
	};
	const getProxyReportInfo = async () => {
		let res = await getProxyReport({});
		if (res.code !== 0) {
			return;
		}
		reportData.value = res.data;
	}

	let information = ref({});
	let fileList1 = ref([]);
	let fileList2 = ref([]);
	let fileList3 = ref([]);
	let fileList4 = ref([]);
	let fileList5 = ref([]);
	let fileList6 = ref([]);

	function infoDetails() {
		merchantDetails().then(res => {
			information.value = res.data
			if (res.data?.reviewStatus == 30 || res.data?.reviewStatus == 10) {
				if (information.value.licenseUrl) {
					fileList4.value.push({
						url: information.value.isCardUrl
					})
					fileList5.value.push({
						url: information.value.theCardUrl
					})
					fileList6.value.push({
						url: information.value.licenseUrl
					})
				}
				ruleForm.name = information.value.name;
				ruleForm.idCard = information.value.idCard;
				ruleForm.isCardUrl = information.value.isCardUrl;
				ruleForm.theCardUrl = information.value.theCardUrl;
				ruleForm.merchantName = information.value.merchantName;
				ruleForm.institutionCode = information.value.institutionCode;
				ruleForm.address = information.value.address;
				ruleForm.licenseUrl = information.value.licenseUrl
				if (ruleForm.licenseUrl) {
					fileList1.value.push({
						url: ruleForm.isCardUrl
					})
					fileList2.value.push({
						url: ruleForm.theCardUrl
					})
					fileList3.value.push({
						url: ruleForm.licenseUrl
					})
				}
				console.log('ruleFormruleFormruleFormruleForm', ruleForm)
			}
		})
	}

	onMounted(async () => {
		info();
		into();
		infoSever();
		infoAsync();
		infTops();
		infoDetails();
		if (route.query.ids) {
			ids.value = route.query.ids;
		}
		await refreshUserInfo();
		if (userInfo.value?.brokerageEnabled) {
			getProxyReportInfo();
		}
	});
</script>

<style lang="scss">
	.head-guidance {
		width: 100%;
		height: 70px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
		position: fixed;
		top: 0;
		z-index: 111;

		.head-guidance-flex {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.image {
				width: 106px;
				height: 40px;
				margin-top: 15px;
				margin-left: 160px;
			}
		}

		.head-right {
			display: flex;
			margin-right: 104px;

			.head-right-flex {
				display: flex;
				align-items: center;
				margin-top: 12px;
				margin-left: 36px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.head-right-flex:hover {
				cursor: pointer;
			}

			.head-right-flex1:hover {
				cursor: pointer;
			}

			.head-right-flex1 {
				display: flex;
				align-items: center;
				padding: 11px 16px;
				background: #ff3333;
				border-radius: 74px 74px 74px 74px;
				margin-top: 13px;

				.home-right {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #fff;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-left: 6px;
				}
			}

			.frame-flex {
				height: 18px;
				border-right: 1px solid #dddddd;
				margin-top: 26px;
				margin-left: 22px;
				padding-right: 44px;
			}
		}
	}

	.rectangle {
		width: 100%;
		height: 52px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
	}

	.rectangle-with {
		width: 67%;
		margin: auto;
		height: 52px;
	}

	.flex-rectange {
		display: flex;
		align-items: center;
		height: 52px;
		margin-left: 22px;
	}

	.current-recy {
		margin-left: 7px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.rectangle-platform {
		width: 1280px;
		position: relative;
		margin: auto;
		margin-top: 21px;
		min-height: 610px;
	}

	.rectngle-plat-vector {
		width: 13%;
		padding: 10px 0px;
		background: #ffffff;
		border-radius: 8px 8px 8px 8px;
		position: absolute;
		left: 0;
		top: 0;
	}

	.rectng-width {
		width: 86%;
		height: 50px;
		border-radius: 0px 10px 10px 0px;
		display: flex;
		align-items: center;
	}

	.image-rectng {
		width: 13px;
		height: 16px;
		margin-left: 18px;
	}

	.title-assrts {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-left: 6px;
	}

	.rectng-width1 {
		background: linear-gradient(90deg, #ff3333 58%, rgba(255, 51, 51, 0.8) 100%);

		.title-assrts {
			color: #fff;
		}
	}

	.rectng-width:hover {
		cursor: pointer;
	}

	.content {
		width: 85%;
		background-color: #fff;
		margin-left: 20px;
		margin-left: auto;
		margin-top: 20px;
		border-radius: 10px;
	}

	.content:hover {
		cursor: default;
	}

	.content-assets {
		padding: 20px 21px;
		padding-: 26px;
	}

	.flex-cement {
		display: flex;
		align-items: center;

		.cement {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #333333;
			margin-left: 8px;
			font-style: normal;
			text-transform: none;
		}
	}

	.border-top {
		width: 99%;
		height: 0px;
		border-top: 1px solid #eeeeee;
		margin-top: 16px;
		padding-top: 16px;
	}

	.flex-const-slice {
		display: flex;
	}

	.title-slice {
		margin-left: 14px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: 2px;
	}

	.title-slice1 {
		color: #ff2f17;
	}

	.december {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 17px;
		color: #aaaaaa;
		font-style: normal;
		text-transform: none;
		margin-left: 5px;
		margin-top: -2px;
	}

	.flex-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-contact {
		margin-top: 60px;
	}

	.el-pagination.is-background .btn-next.is-active,
	.el-pagination.is-background .btn-prev.is-active,
	.el-pagination.is-background .el-pager li.is-active {
		background-color: #ff3333;
	}

	.rectangle1 {
		width: 85%;
		margin-left: auto;
		height: 78px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px 8px 8px 8px;
		margin-top: -37px;
		position: relative;
		// z-index: -1;

		.rectgle-flex {
			width: 100%;
			height: 34px;
			// background: rgba(255, 234, 234, 0.5);
			border-radius: 8px 8px 8px 8px;
			position: absolute;
			top: 0;
			z-index: -1;
		}
	}

	.flex-post {
		display: flex;
	}

	.flex-title-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin-left: 35px;
		font-style: normal;
		text-transform: none;
		margin-top: 2px;
		width: 37vw;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.flex-assets {
		margin-left: 35px;
		margin-top: 13px;

		.flex-text {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 16px;
			font-style: normal;
			text-transform: none;
		}

		.time {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}
	}

	.flex-right {
		position: absolute;
		display: flex;
		align-items: center;
		right: 24px;
		top: 31%;
	}

	.flex-right:hover {
		cursor: pointer;
	}

	.flex-title-views {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ff2f17;
		font-style: normal;
		text-transform: none;
		margin-top: -6px;
		margin-right: 10px;
	}

	.rectangleSpan {
		width: 100%;
		height: 49px;
		background: #ff3333;
		border-radius: 10px 10px 0px 0px;
		display: flex;
	}

	.reactnale-assets {
		width: 216px;
		height: 49px;
		background: linear-gradient(90deg, rgba(78, 0, 0, 0) 0%, rgba(78, 0, 0, 0.5) 100%);
		display: flex;
		line-height: 65px;
		padding-left: 20px;
	}

	.distributors {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 13px;
		color: #ffffff;
		font-style: normal;
		text-transform: none;
		margin-top: -6px;
		margin-left: 5px;
	}

	.commission {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		font-style: normal;
		text-transform: none;
	}

	.symbol {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 12px;
		color: #ffffff;
		font-style: normal;
		text-transform: none;
		margin-left: 10px;
	}

	.money {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #ffffff;
		font-style: normal;
		text-transform: none;
	}

	.reactnale-assets1 {
		height: 49px;
		display: flex;
		line-height: 61px;
		padding: 0px 20px;
	}

	.border-left {
		width: 14px;
		height: 14px;
		border-left: 1px solid #aa1d27;
		margin-top: auto;
		margin-bottom: auto;
	}

	.flex-usere {
		display: flex;
		align-items: center;

		.user-info {
			margin-left: 18px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 24px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}

		.user-phone {
			margin-left: 18px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			font-style: normal;
			text-transform: none;
			margin-top: 3px;
		}
	}

	.user-left {
		margin-left: 105px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 24px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.user-price {
		font-size: 24px;
	}

	.user-title {
		font-size: 12px;
	}

	.after-real-name {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #333333;
		font-style: normal;
		text-transform: none;
		margin-top: 8px;
	}

	.withdrawal {
		width: 110px;
		height: 32px;
		background: #cfcfcf;
		border-radius: 4px 4px 4px 4px;
		line-height: 32px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		font-style: normal;
		text-transform: none;
		text-align: center;
	}

	.withdrawal:hover {
		cursor: pointer;
	}

	.flex-top-bor {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
	}

	.flex-left {
		display: flex;
		align-items: center;
	}

	.flex-rights {
		display: flex;
		align-items: center;
		margin-left: auto;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ff2f17;
		font-style: normal;
		text-transform: none;
	}

	.pagination-contact {
		margin-top: 60px;
	}

	.el-pagination.is-background .btn-next.is-active,
	.el-pagination.is-background .btn-prev.is-active,
	.el-pagination.is-background .el-pager li.is-active {
		background-color: #ff3333;
	}

	.want-to-sell {
		margin-top: 60px;
		width: 88px;
		height: 42px;
		background: #ff3333;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #ff3333;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		line-height: 42px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.want-to-sell:hover {
		cursor: pointer;
	}

	.bor-top1 {
		width: 120px;
		border-top: 1px solid #eeeeee;
		margin-top: 13px;
		padding-top: 13px;
		margin-left: 23px;
	}

	.flex-list-tiele {
		display: flex;
	}

	.disabled .el-upload--picture-card {
		display: none !important;
	}

	.direction {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 12px;
	}

	.after-real-scikck {
		text-align: center;
		margin-left: 18px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #333333;
		font-style: normal;
		text-transform: none;
		margin-top: 8px;
	}

	.downloadFile {
		color: #6AA5FE;
	}

	.downloadFile:hover {
		cursor: pointer;
	}
</style>